interface Props {
  totalCarbs: number;
  totalConsumedKcal: number;
  totalBurnedKcal: number;
  totalDuration: string;
}

export default function FuelSummaryCard(_props: Props) {
  // FuelStats component is available but currently disabled
  return null;
}
